var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"hdp-uf-hfs"},[_c('iframe',{staticStyle:{"display":"none"},attrs:{"src":_vm.iframeSrc}}),_vm._v(" "),_c('el-button',{attrs:{"type":"primary","icon":"el-icon-download"},on:{"click":function($event){_vm.downloadTemplate()}}},[_vm._v(" "+_vm._s(_vm.btnName)+" ")])],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-21bc07c4","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/common/LapDownloadBtn.vue
// module id = null
// module chunks = 